import script from "./IndexOpportunity.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexOpportunity.vue?vue&type=script&setup=true&lang=js"

import "./IndexOpportunity.vue?vue&type=style&index=0&id=25a56401&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a56401"]])

export default __exports__